// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-58e608b5]{font-size:20px;margin-bottom:16px}.footer-inputs[data-v-58e608b5]{margin-top:16px}.button-bottom[data-v-58e608b5]{margin-top:94px}", ""]);
// Exports
module.exports = exports;
